<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-store-alt page-icon"></i>
			</div>

			<div>
				<div class="text-center">LISTA</div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2 disabled"><i class="fa fa-lg mb-2 fa-search"></i><br />Szűrő</button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<div class="float-end pt-4" style="width:250px;">
							<div class="input-group">
								<input type="text" class="form-control" id="status-search" placeholder="Keresés..." oninput="Anvil.page.quickSearch($(this).val())" />
								<span class="input-group-text"><i class="fa fa-search"></i></span>
							</div>
						</div>

						<h2>Telephelyek</h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Order</li>
							<li class="breadcrumb-item active">Telephelyek</li>
						</ol>

						<!--<img src="assets/santa.png" style="position:absolute; right:270px; top:14px;z-index: 10;" />-->
					</div>

					<%- include('/ui/map', {
						name: 'site',
						list: sites,
						search_fields: [ 'name', 'full_address', 'company_name', 'aps' ],
						params: {
							popup_template: '/c_order/terminal/popup_site',
							list_template: '/c_order/terminal/map_list',
							tooltip_field: 'name',
							styles: Anvil.models.c_order.Site.Types,
							style_field: 'type'
						}
					}) %>
				</div>
			</div>

		</div>
	</div>
</div>

<script>
Object.assign(Anvil.page, {

	async quickSearch (expression) {
		Anvil.models.components.Map.find('#site_map').filter(expression)
	},

	async openSite (company_db_id, site_id) {
		const site = Anvil.page.sites.data.find(s => s.company_db_id == company_db_id && s.id == site_id)
		Anvil.render('c_order/terminal/panel_site', site, '#site_map_overlay')
		$('#site_map_overlay').removeClass('d-none')
		Anvil.models.components.Map.find('#site_map')._leaflet.invalidateSize()

		// Init tooltips
		var tooltip_els = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
		var tooltip_list = tooltip_els.map((el) => new bootstrap.Tooltip(el))
	},

	async closeSite () {
		$('#site_map_overlay').addClass('d-none')
		Anvil.models.components.Map.find('#site_map')._leaflet.invalidateSize()
	},

	async openTerminal (machine_id) {

		// Find terminal
		var terminal = undefined
		find_terminal:
		for (const site of Anvil.page.sites.data) {
			for (const storage of site.storages) {
				terminal = storage.terminals.find(t => t.machine_id == machine_id)
				if (terminal !== undefined) break find_terminal
			}
		}

		if (terminal !== undefined) {
			// Open edit modal
			Anvil.exec('c_order/terminal/modal_edit', terminal)
		}
	},

	async connect_with_anydesk (machine_id) {

		// Find terminal
		var terminal = undefined
		var terminal_site = undefined
		find_terminal:
		for (const site of Anvil.page.sites.data) {
			for (const storage of site.storages) {
				terminal = storage.terminals.find(t => t.machine_id == machine_id)
				if (terminal !== undefined) {
					terminal_site = site
					break find_terminal
				}
			}
		}

		if (terminal !== undefined) {
			// Request confirmation
			Anvil.confirm({
				title: 'Anydesk kapcsolat',
				message: `
					<p>Biztosan szeretnél csatlakozni a kiválasztott terminálhoz?</p>
					<table style="font-size:0.9em;">
						<tr>
							<td class="pe-3">Cég</td>
							<td><strong>${terminal_site.company_name}</strong></td>
						</tr>
						<tr>
							<td class="pe-3">Telephely</td>
							<td><strong>${terminal_site.name}</strong></td>
						</tr>
						<tr>
							<td class="pe-3" valign="top">Terminál</td>
							<td><strong>${terminal.device_info.hostname || terminal.name}</strong><br /><br /></td>
						</tr>
						<tr>
							<td class="pe-3">Anydesk ID</td>
							<td><strong>${terminal.anydesk_id}</strong></td>
						</tr>
					</table>
				`,
				btn_ok: `<i class="fa fa-headset me-2"></i>Csatlakozás`,
				btn_cancel: `<i class="fa fa-running me-2"></i>Mégse`,
				btn_ok_class: 'warning',
				onclose: (confirmed) => {
					if (confirmed) {
						window.open(`anydesk:${terminal.anydesk_id}`, '_self')
					}
				}
			})
		}
	}
})
</script>
